/* @ngInject */

export default ($rootScope, helperService, helperPdfService) => {
  /**
   * Prepare signatures details.
   *
   * @param {Array} contacts
   * @param {Object} ticketOwner
   *
   * @returns {Array}
   */
  const prepareSignaturesDetails = ({
    contacts,
    contactLabels,
    ticket,
    ticketOwner,
    pageBreak,
    authorisationText,
    showIntroducer
  }) => {
    const content = [];
    if (contacts?.length) {
      content.push(
        helperPdfService.createHeader({
          title: 'AUTHORISATION',
          pageBreak: pageBreak || ''
        })
      );
      content.push({
        text:
          authorisationText ||
          'By signing this document, you authorise us to make a request on your behalf to obtain information about you from one or more credit reporting service(s) and credit provider(s). That information will assist us in providing our services to you.',
        style: ['value', 'marginTop']
      });
      let signatories = [];
      const companies = _.find(contacts, (c) => c.isCompany);
      if (companies) {
        signatories = _.filter(
          companies?.company?.information?.individuals,
          (i) => i.isDirector
        );
      }
      const persons = _.filter(contacts, (c) => !c.isCompany);
      signatories = signatories.concat(persons);
      if (signatories.length) {
        content.push({
          text: '',
          margin: [0, 20, 0, 0]
        });
        const len = signatories?.length || 0;
        if (len) {
          content.push({
            table: {
              widths: ['45.5%', '8%', '45.5%'],
              body: []
            },
            layout: {
              defaultBorder: false,
              hLineWidth() {
                return 0.5;
              }
            }
          });
        }
        let body = 0;
        for (let c = 0; c < len; c += 1) {
          const contact = signatories[c];
          const contactType = contact?.docType
            ? helperService.getContactTypeInDeal({
                ticket,
                contactLabels,
                idContact: contact.id
              })
            : 'Director';
          if (c % 2 === 0) {
            content[content.length - 1].table.body.push(['', '', ''], ['', '', '']);
            content[content.length - 1].table.body[body][0] = {
              text: [
                {
                  text: `${c >= 2 ? '\n\n' : ''}${
                    contact.getName() || `${contact.firstName} ${contact.familyName}`
                  } - ${contactType}\n`,
                  style: 'value'
                },
                {
                  text: `\n\n[sig|req|signer${c}|Signature|Signature${c}]`,
                  style: ['value', 'noColor']
                }
              ],
              border: [false, false, false, true]
            };
            content[content.length - 1].table.body[body + 1][0] = {
              text: [
                { text: '\nDate\n', style: 'value' },
                {
                  text: `\n\n[date|noreq|signer${c}|SignatureDate|Signatured${c}]`,
                  style: ['value', 'noColor']
                }
              ],
              border: [false, false, false, true]
            };
          } else {
            content[content.length - 1].table.body[body][2] = {
              text: [
                {
                  text: `${c >= 3 ? '\n\n' : ''}${
                    contact.getName() || `${contact.firstName} ${contact.familyName}`
                  } - ${contactType}\n`,
                  style: 'value'
                },
                {
                  text: `\n\n[sig|req|signer${c}|Signature|Signature${c}]`,
                  style: ['value', 'noColor']
                }
              ],
              border: [false, false, false, true]
            };
            content[content.length - 1].table.body[body + 1][2] = {
              text: [
                { text: '\nDate\n', style: 'value' },
                {
                  text: `\n\n[date|noreq|signer${c}|SignatureDate|Signatured${c}]`,
                  style: ['value', 'noColor']
                }
              ],
              border: [false, false, false, true]
            };
            body += 2;
          }
        }
      }
      if (showIntroducer && ticketOwner) {
        content.push({ text: '', margin: [0, 30, 0, 0] });
        content.push(
          helperPdfService.createSubHeader({
            title: 'INTRODUCER'
          })
        );
        content.push({
          table: {
            widths: ['45.5%', '8%', '45.5%'],
            body: [
              [
                {
                  text: [
                    { text: `${ticketOwner.getName()}\n`, style: 'value' },
                    {
                      text: '\n\n',
                      style: 'value'
                    }
                  ],
                  border: [false, false, false, true]
                },
                '',
                ''
              ],
              [
                {
                  text: [
                    { text: '\nDate\n', style: 'value' },
                    {
                      text: '\n\n',
                      style: 'value'
                    }
                  ],
                  border: [false, false, false, true]
                },
                '',
                ''
              ]
            ]
          },
          layout: {
            defaultBorder: false,
            hLineWidth() {
              return 0.5;
            }
          }
        });
      }
    }
    return content;
  };

  return {
    prepareSignaturesDetails
  };
};
